'use client';

import { Radio as RadioPrimitive } from '@base-ui/react/radio';
import { RadioGroup as RadioGroupPrimitive } from '@base-ui/react/radio-group';

import { cn } from '@playbooks/ui/lib/utils';

function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props) {
	// Theme
	const rootClassName = cn('grid w-full gap-2', className);

	// Render
	return <RadioGroupPrimitive data-slot='radio-group' className={rootClassName} {...props} />;
}

function RadioGroupItem({ className, ...props }: RadioPrimitive.Root.Props) {
	// Theme
	const rootClassName = cn(
		'group/radio-group-item peer relative flex aspect-square size-4 shrink-0 rounded-full border border-border-strong bg-surface-control outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-focus focus-visible:ring-3 focus-visible:ring-focus/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-danger aria-invalid:ring-3 aria-invalid:ring-danger/20 aria-invalid:aria-checked:border-action dark:aria-invalid:border-danger/50 dark:aria-invalid:ring-danger/40 data-checked:border-action data-checked:bg-action data-checked:text-action-foreground',
		className,
	);

	// Render
	return (
		<RadioPrimitive.Root data-slot='radio-group-item' className={rootClassName} {...props}>
			<RadioPrimitive.Indicator data-slot='radio-group-indicator' className='flex size-4 items-center justify-center'>
				<span className='absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-action-foreground' />
			</RadioPrimitive.Indicator>
		</RadioPrimitive.Root>
	);
}

export { RadioGroup, RadioGroupItem };
